import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { IPricingProfile } from 'pricing/types';
import { AttachExistingVendorQuote } from 'quotes/components';
import { ICustomerQuote, IVendorQuote } from 'quotes/types';
import { Variant } from 'theme/enums';

interface IProps {
  quote?: ICustomerQuote;
  pricingProfile?: IPricingProfile;
  onAttachVendorQuoteSuccess: (attachedQuotes: IVendorQuote[]) => void;
}

export const AttachExistingVendorQuotesButton = ({
  quote,
  pricingProfile,
  onAttachVendorQuoteSuccess,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const handleSuccess = (attachedQuotes: IVendorQuote[]) => {
    onAttachVendorQuoteSuccess(attachedQuotes);
    setTimeout(() => {
      setIsOpen(false);
    }, 1000);
  };

  return (
    <>
      <Button
        text={t('buttonLabelAttachExistingVendorQuotes')}
        variant={Variant.SOLID}
        onClick={() => setIsOpen(true)}
      />

      <AttachExistingVendorQuote
        isOpen={isOpen}
        quote={quote}
        pricingProfile={pricingProfile}
        onAttachVendorQuoteSuccess={handleSuccess}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};
